import { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { closeChangeDateUndeliveredAwbModal } from "../../../../redux/reducer/expedition.reducer";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../components/CustomButton";
import Text from "../../../../styleguide/Text";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import {
  fetchUndeliveredAwb,
  postChangePickingDateUndeliveredAwb,
} from "../../../../redux/api/expedition.api";
import { dateAndTimeForDatabase } from "../../../../utils/dateAndTime";
import DateTimePicker from "../../../../components/misc/DateTimePicker";

function ChangePickingDateModal() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();

  const {
    expedition: {
      isChangeDateUndeliveredAwbModalOpen,
      selectedUndeliveredAwbForChangingDate,
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!selectedUndeliveredAwbForChangingDate) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        postChangePickingDateUndeliveredAwb({
          id_doctrans: selectedUndeliveredAwbForChangingDate.id_doctrans,
          data_ridicare: dateAndTimeForDatabase(selectedDate),
        }),
      );

      if (
        checkEndpointStatus(
          resultAction,
          postChangePickingDateUndeliveredAwb,
        ) !== endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(
          resultAction,
          postChangePickingDateUndeliveredAwb,
        ) === endpointStatus.fulfilled
      ) {
        const {
          page,
          rowsPerPage,
          pctlivrare,
          nodDestinatie,
          doc_trans,
          status,
        } = routeParams;

        dispatch(
          fetchUndeliveredAwb({
            page: page,
            perPage: rowsPerPage,
            pctlivrare: pctlivrare,
            nodDestinatie: nodDestinatie,
            doc_trans: doc_trans,
            status: status,
          }),
        );

        dispatch(closeChangeDateUndeliveredAwbModal());
        setSelectedDate(null);

        handleClose && handleClose();
      }
    },
    [
      selectedUndeliveredAwbForChangingDate,
      dispatch,
      routeParams,
      selectedDate,
    ],
  );

  const isSubmitDisabled =
    !selectedUndeliveredAwbForChangingDate?.id_doctrans || !selectedDate;

  const onClose = useCallback(() => {
    dispatch(closeChangeDateUndeliveredAwbModal());
    setSelectedDate(null);
  }, [dispatch]);

  return (
    <>
      <ModalWrapper
        show={!!isChangeDateUndeliveredAwbModalOpen}
        title="Editare data ridicarii"
        modalSize="sm"
        handleClose={onClose}>
        <div className="d-flex flex-column">
          <DateTimePicker
            label="Data si ora ridicarii"
            value={selectedDate}
            minDate={new Date()}
            handleChangeDate={(newDate) => setSelectedDate(newDate)}
          />
        </div>

        <CustomButton
          type="submit"
          variant="contained"
          fullWidth
          className="btn btn-lg btn-primary w-100 mt-5"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={handleOnSubmit}>
          <Text variant="body1" className="indicator-label" isBold>
            Salveaza
          </Text>
        </CustomButton>
      </ModalWrapper>
    </>
  );
}

export default ChangePickingDateModal;
